import React, { useEffect } from 'react';
import './strabismus.less';
import Footer from "../../../components/Footer/Footer";
import { useScrollHeader } from '../../../hooks';

function Strabismus({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return (
    <div className="Strabismus">
      <div className='Strabismus_cover'>
        <div className="Strabismus_cover-content ta_c c_ff pageMargin">
          <div className="Glaucoma_cover-title">斜视术后康复数字疗法</div>
          <div className='Glaucoma_cover-titleEn'>Digital therapy for postoperative rehabilitation of strabismus</div>
        </div>
      </div>
      {/* PC端 */}
      <div className='Strabismus_section-Pc flex_row'>
        <div className="Strabismus_section-img">
          <img
            style={{ width: '100%' }}
            src='./images/xs/xs-img.png'
            alt=''
          />
        </div>
        <div className='Strabismus_section-right'>
          <div className='fz_32 fw_700 lh_38 mt_82 pb_80 Glaucoma_linear-gradient'>集视医疗正在开发一种斜视全周期管理方案，涵盖长期的眼动追踪、15度以内的斜视手术替代治疗、术后矫正训练等模块。</div>
          <div className='fz_28 fw_500 lh_32 mt_25 Glaucoma_linear-gradient'>编号 FST-AO1-003</div>
          <div className='fz_24 fw_500 lh_32 mt_6'>可穿戴智能眼镜，用于24h眼动监测</div>
          <div className='fz_28 fw_500 lh_32 mt_80 Glaucoma_linear-gradient'>编号 FST-AO1-004</div>
          <div className='fz_24 fw_500 lh_32 mt_6'>全新的融像训练方案，用于斜视矫正训练和斜视术后视觉功能重建</div>
          <div className='fz_28 fw_500 lh_32 mt_70 Glaucoma_linear-gradient'>背景</div>
          <div className='fz_16 fw_500 lh_24 mt_6 c_85899E'>斜视是导致儿童视觉发育障碍的常见眼病。斜视除了影响美观外,还会导致弱视及双眼单视功能不同程度的丧失。早期治疗斜视可以在矫正眼位、恢复外观的基础上,促进视力发育和双眼视觉功能的建立。</div>
          <div className='fz_28 fw_500 lh_32 mt_70 Glaucoma_linear-gradient'>意义</div>
          <div className='fz_16 fw_500 lh_24 mt_6 c_85899E pb_20'>FST-A01-004通过将二维视频转化为三维随机点进行双眼整合训练，患者在训练时只需要观看和理解视频内容即可,无需完成枯燥的判断任务，从而进一步提高训练的依从性!</div>
        </div>
      </div>
      {/* 移动端 */}
      <div className="Strabismus_section-Mobile">
        <div className="pageMargin flex_col flex_ai-c">
          <div className='fz_24 fw_700 lh_28 mt_60 pb_28 ta_c Glaucoma_linear-gradient' style={{ width: '90%' }}>
            <div>集视医疗正在开发一种斜视全周期管理方案，</div>
            涵盖长期的眼动追踪、15度以内的斜视手术替代治疗、术后矫正训练等模块。
          </div>
        </div>
        <div className='Glaucoma_section-line'></div>
        <img
          style={{ width: '100%' }}
          src='./images/xs/xs-img.png'
          alt=''
        />
        <div className='Glaucoma_section-line'></div>
        <div className='pageMargin flex_col flex_ai-c ta_c'>
          <div className='fz_18 fw_500 lh_21 mt_20 Glaucoma_linear-gradient'>编号 FST-AO1-003</div>
          <div className='fz_12 fw_500 lh_16 mt_4 mb_20' style={{ width: '74%' }}>可穿戴智能眼镜，用于24h眼动监测</div>
        </div>
        <div className='Glaucoma_section-line'></div>
        <div className='pageMargin flex_col flex_ai-c ta_c'>
          <div className='fz_18 fw_500 lh_21 mt_20 Glaucoma_linear-gradient'>编号 FST-AO1-004</div>
          <div className='fz_12 fw_500 lh_16 mt_4 mb_20' style={{ width: '74%' }}>全新的融像训练方案，用于斜视矫正训练和斜视术后视觉功能重建</div>
        </div>
        <div className='Glaucoma_section-line'></div>
        <div className='pageMargin flex_col flex_ai-c ta_c'>
          <div className='fz_18 fw_500 lh_21 mt_20 Glaucoma_linear-gradient'>背景</div>
          <div className='fz_12 fw_500 lh_16 mt_4 mb_20 c_85899E' style={{ width: '74%' }}>斜视是导致儿童视觉发育障碍的常见眼病。斜视除了影响美观外,还会导致弱视及双眼单视功能不同程度的丧失。早期治疗斜视可以在矫正眼位、恢复外观的基础上,促进视力发育和双眼视觉功能的建立。</div>
        </div>
        <div className='Glaucoma_section-line'></div>
        <div className='pageMargin flex_col flex_ai-c ta_c'>
          <div className='fz_18 fw_500 lh_21 mt_20 Glaucoma_linear-gradient'>意义</div>
          <div className='fz_12 fw_500 lh_16 mt_4 mb_40 c_85899E' style={{ width: '74%' }}>FST-A01-004通过将二维视频转化为三维随机点进行双眼整合训练，患者在训练时只需要观看和理解视频内容即可,无需完成枯燥的判断任务，从而进一步提高训练的依从性!</div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Strabismus;